import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';
import { FetchAPI, ModalService, Tooltip } from '@philips-internal/oswald-ui-components';
import Controller, { OnDynamicContentRender, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { ReactComponent as DownloadSVG } from '../../../resources/assets/commons/download.svg';
import { FragmentNames, SlaFileListAliases } from '../../codegen';
import { FileJson } from '../../interfaces';
import { SlaService } from '../../services';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.SLA_FILE_LIST })
export default class SlaFileListController extends BaseController {

  @Inject(SlaFileListAliases.FETCH_SLA_FILE)
  fetchSla!: FetchAPI;

  @OnMount({ target: SlaFileListAliases.LAYOUT_SLA_FILE })
  onMount(): void {
    const event = new CustomEvent('updateModulesRoute', { detail: { moduleId: 'sla-file' } });
    dispatchEvent(event);
  }

  @OnDynamicContentRender({ target: SlaFileListAliases.TABLE_SLA_FILE })
  onRenderColumnsExternal(event: RenderEvent): void {
    switch (event.entry) {
      case 'action':
        event.render((data: FileJson): ReactElement => {
          const clickStyle = {
            cursor: 'pointer',
          };
          const clickSpaceStyle = {
            ...clickStyle,
            marginLeft: '4px',
          };
          const actionsStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          };
          return (<div style={actionsStyle}>
            <Tooltip value="product-manual.download">
              <div style={clickSpaceStyle}>
                <DownloadSVG width={24} height={24} onClick={() => this.download(data)}/>
              </div>
            </Tooltip>
          </div>);
        });
        break;
    }
  }

  download(data: FileJson): void {
    ModalService.openDialog({
      id: 'download-modal',
      fragment: 'download-modal',
      closeable: false,
    });
    SlaService.download(data.id, data.name)
      .catch(console.error)
      .finally(() => {
        ModalService.close('download-modal');
      });
  }

}
